import PurchaseOrderDatatable from '@/components/CustomDatatable/PurchaseOrderDatatable/PurchaseOrderDatatable';
import { Component, Ref, Vue } from 'vue-property-decorator';

@Component<PurchaseOrders>({})
export default class PurchaseOrders extends Vue {

  // #region @Props
  // #endregion

  // #region @Refs

  @Ref()
  protected purchaseOrderDatatable!: PurchaseOrderDatatable;

  // #endregion

  // #region Props
  // #endregion

  // #region Plugin props

  public $pageTitle = 'Purchase Orders';

  // #endregion

  // #region Lifecycle hooks / Init

  protected mounted(): void {
    this.initialize();
  }

  protected initialize(): void {
    this.emitBreadcrumbs();
  }

  // #endregion

  // #region Handlers
  // #endregion

  // #region Helpers

  protected emitBreadcrumbs(): void {
    this.$root.$emit('breadcrumbUpdated', {
      crumb: [{ name: 'Purchase Orders' }]
    });
  }

  public refreshPurchaseOrderDatatable() {
    this.purchaseOrderDatatable ? this.purchaseOrderDatatable.refresh() : null;
  }

  // #endregion


  // #region API Requests
  // #endregion

  // #region Getters & Setters
  // #endregion

  // #endregion

  // #region @Watchers
  // #endregion
}
